import Vue from 'vue'
import Router from 'vue-router'
import Start from '@/pages/Start'
import Referenzen from '@/pages/Referenzen'
import Jobs from '@/pages/Jobs'
import Impressum from '@/pages/Impressum'
import Handwerk from '@/pages/Handwerk'
import Datenschutz from '@/pages/Datenschutz'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Start',
      component: Start
    },
    {
      path: '/home',
      name: 'Start',
      component: Start
    },
    {
      path: '/jobs',
      name: 'Jobs',
      component: Jobs
    },
    {
      path: '/referenzen',
      name: 'Referenzen',
      component: Referenzen
    },
    {
      path: '/handwerk',
      name: 'Handwerk',
      component: Handwerk
    },
    {
      path: '/impressum',
      name: 'Impressum',
      component: Impressum
    },
    {
      path: '/datenschutz',
      name: 'Datenschutz',
      component: Datenschutz
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js